// CustomerCreateJobModal.tsx
import React, { useRef } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Draggable from 'react-draggable';
import CreateJob from './CreateJob';

interface CustomerCreateJobModalProps {
  isOpen?: boolean;
  toggle?: () => void;
  onJobCreated?: () => void;
}

const CustomerCreateJobModal: React.FC<CustomerCreateJobModalProps> = ({
  isOpen = false,
  toggle = () => { },
  onJobCreated = () => { }
}) => {
  const nodeRef = useRef(null);

  const handleJobCreated = (jobId: string) => {
    console.log('Job created with ID:', jobId);
    onJobCreated();
    setTimeout(() => {
      toggle();
    }, 3000);
  };

  const handleCloseModal = () => {
    toggle();
  };

  return (
    <Draggable handle=".modal-header" nodeRef={nodeRef}>
      <div ref={nodeRef}>
        <Modal
          size="xl"
          isOpen={isOpen}
          toggle={handleCloseModal}
          className="xl-modal"
          modalClassName="xl-modal-dialog"
          contentClassName="xl-modal-content"
        >
          <ModalHeader
            className="modal-title"
            id="myExtraLargeModalLabel"
            toggle={handleCloseModal}
          >
            Create Your Project
          </ModalHeader>

          <ModalBody>
            <CreateJob 
              onJobCreated={handleJobCreated}
              showHeader={false}
              redirectOnSuccess={false}
            />
          </ModalBody>
        </Modal>
      </div>
    </Draggable>
  );
};

export default CustomerCreateJobModal;